/**
 * Who may open the email-booking setup wizard (orchestrator decision 1): an
 * administrator of the acting partner company. The partner API sends
 * `company_role_id` (1 = company administrator) and an empty `company` for
 * admins without an acting partner company. Operators/drivers of a company
 * (other role ids) are kept out even though they have a company. The backend
 * enforces the same rule; this only keeps the UI honest.
 */
export const COMPANY_ADMIN_ROLE_ID = 1;

export interface EmailOnboardingAccessUser {
  company?: string | null;
  company_role_id?: number | string | null;
}

export const canConfigureEmailOnboarding = (
  user: EmailOnboardingAccessUser | null | undefined,
): boolean => {
  if (!user) {
    return false;
  }
  const company = String(user.company ?? "").trim();
  if (!company) {
    return false;
  }
  return Number(user.company_role_id) === COMPANY_ADMIN_ROLE_ID;
};
